<template>
  <div class="vx-row w-full map-events m-0">
    <div class="vx-col sm:w-1/5 lg:w-1/5 relative w-full" v-if="view_state === 2">
      <div class="cursor-pointer font-size-12 text-right w-full close-button absolute top-0 right-0" @click="closeDetail">
        <feather-icon icon="XIcon" svgClasses="h-4 w-4" />
      </div>
      <div class="w-full">
        <cam-controller :event="selectedMarker.event" :camera_id="selectedMarker.event.camera_id" :image="selectedMarker.event.event_image"/>
      </div>
      <div class="w-full text-right px-2 mt-2 ">
        <events-detail :event="selectedMarker.event" :data_map="selectedMarker.data_map"/>
      </div>
    </div>
    <div v-else class="vx-col h-full sm:w-1/5 lg:w-1/5 w-full">
      <div class="p-2" v-show="treeData !== null">
        <vue-tree-list
          :model="treeData"
          v-bind:default-expanded="true"
          @click="list_clicked"
        >
        </vue-tree-list>
      </div>
    </div>
    <div class="vx-col sm:w-4/5 lg:w-4/5 w-full" >
      <div class="w-full">
        <google-map id="map" ref="map" :options="defaultMapOptions">
          <div
            v-if="markers.length !== 0"
            v-for="(marker, index) in markers"
            :key="index">
            <google-map-marker
              :position.sync="marker.position"
              :icon="(showFire) ? getTowerIcon : getFireIconColor(marker.event.status)"
              :clickable="true"
              :options="{optimized: false}"
              @click="toggleInfoWindow(marker)"
              class="marker-style"
            />

            <div v-if="selectedMarker.event.id === marker.event.id">
<!--              <google-map-infowindow
                :position="marker.position"
                :show.sync="marker.showInfo"
                :options="infoOptions"
                @info-window-clicked="infoClicked(marker.event)">

                <div>
                  <h5 class="pb-2 w-full">Bilgiler</h5>
                  <div class="control-wrapper vx-col px-1 pb-2">
                    <div class=" vx-row flex flex-wrap m-0">
                    <div class="vx-col w-1/2">
                      <div class="control-title">Bölge :</div>
                      <div class="control-value">{{getEventPropString(marker.event.bolge_adi) }}</div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="control-title">İşletme :</div>
                      <div class="control-value">{{getEventPropString(marker.event.isletme_adi)}}</div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="control-title">Kule Adı :</div>
                      <div class="control-value">{{getEventPropString(marker.event.kule_adi)}}</div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="control-title">Şeflik Adı :</div>
                      <div class="control-value">{{getEventPropString(marker.event.seflik_adi)}}</div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="control-title">Sıcaklık :</div>
                      <div class="control-value">{{getEventPropString(marker.event.sicaklik)}} °C</div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="control-title">Nem :</div>
                      <div class="control-value">{{getEventPropString(marker.event.nem)}}%</div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="control-title">Rüzgar Yönü :</div>
                      <div class="control-value">{{getEventPropString(marker.event.ruzgar_acisi)}}° {{getEventPropString(marker.event.ruzgar_yonu)}}</div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="control-title">Rüzgar Hızı : </div>
                      <div class="control-value">{{getEventPropString(parseFloat(marker.event.ruzgar_hizi) * 3.6).toFixed(2).toString()}} km/s</div>
                    </div>
                    <div class="vx-col w-full">
                      <div class="control-title">Yangın Koordinatı :</div>
                      <div class="control-value">{{getEventCoordString(marker.event.yangin_koordinati)}}</div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="control-title">Yangın Rakımı :</div>
                      <div class="control-value">{{getEventPropString(marker.event.yangin_rakimi)}} m</div>
                    </div>
                    <div class="vx-col w-1/2">
                      <div class="control-title">Yangın Uzaklığı :</div>
                      <div class="control-value">{{getEventPropString(marker.event.yangin_uzakligi)}} m</div>
                    </div>
                  </div>
                  </div>

                </div>
              </google-map-infowindow>-->


              <google-map-marker
                v-if="marker.event.yangin_koordinati !== '' && view_state === 2"
                :position.sync="marker.yangin"
                :icon="getFireIconColor(marker.event.status)"
                @click="toggleFireInfoWindow(marker)"
                :clickable="true"
                :options="{optimized: false}"
                class="marker-style"
              />
              <google-map-infowindow
                :position="marker.yangin"
                :show.sync="marker.showFireInfo"
                :options="infoOptions"
                @info-window-clicked="infoClicked(marker.event)">
                <div>
                  <img class="info-image" :src="getEventImageUrl(marker.event.event_image)" />
                  <h5 class="pb-2 w-full">Bilgiler</h5>
                  <div class="control-wrapper vx-col px-1 pb-2">
                    <div class=" vx-row flex flex-wrap m-0">
                      <div class="vx-col w-1/2">
                        <div class="control-title">Bölge :</div>
                        <div class="control-value">{{getEventPropString(marker.data_map.bolge.name) }}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">İşletme :</div>
                        <div class="control-value">{{getEventPropString(marker.data_map.isletme.name)}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Kule Adı :</div>
                        <div class="control-value">{{getEventPropString(marker.data_map.kule.name)}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Şeflik Adı :</div>
                        <div class="control-value">{{getEventPropString(marker.data_map.seflik.name)}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Sıcaklık :</div>
                        <div class="control-value">{{getEventPropString(marker.event.sicaklik)}} °C</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Nem :</div>
                        <div class="control-value">{{getEventPropString(marker.event.nem)}}%</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Rüzgar Yönü :</div>
                        <div class="control-value">{{getEventPropString(marker.event.ruzgar_acisi)}}° {{getEventPropString(marker.event.ruzgar_yonu)}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Rüzgar Hızı : </div>
                        <div class="control-value">{{getEventPropString(parseFloat(marker.event.ruzgar_hizi) * 3.6) === '-' ? '-' : getEventPropString(parseFloat(marker.event.ruzgar_hizi) * 3.6).toFixed(2).toString()}} km/s</div>
                      </div>
                      <div class="vx-col w-full">
                        <div class="control-title">Yangın Koordinatı :</div>
                        <div class="control-value">{{getEventCoordString(marker.event.yangin_koordinati)}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Yangın Rakımı :</div>
                        <div class="control-value">{{getEventPropString(marker.event.yangin_rakimi)}} m</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Yangın Uzaklığı :</div>
                        <div class="control-value">{{getEventPropString(marker.event.yangin_uzakligi)}} m</div>
                      </div>
                    </div>
                  </div>

                </div>
              </google-map-infowindow>

              <google-map-circle

                v-if="marker.event.yangin_uzakligi !== '' && view_state === 2"
                :radius="marker.event.yangin_uzakligi * 1.1"
                :center="getTowerLocationFromEvent(marker.event).position"
              />
              <google-map-polyline
                v-if="marker.event.yangin_uzakligi !== '' && view_state === 2"
                :path="getPathFromEvent(marker.event)"
                :stroke-color="'#ff5722'"
                :stroke-weight="3"
              />

            </div>

            <div v-else-if="marker.event.yangin_koordinati !== '' && view_state === 1" >
              <google-map-marker
                :position.sync="marker.yangin"
                :icon="getFireIconColor(marker.event.status)"
                @click="toggleFireInfoWindow(marker)"
                :clickable="true"
                :options="{optimized: false}"
                class="marker-style"
              />

              <google-map-infowindow
                :position="marker.yangin"
                :show.sync="marker.showFireInfo"
                :options="infoOptions"
                @info-window-clicked="infoClicked(marker.event)">

                <div>
                  <img class="info-image" :src="getEventImageUrl(marker.event.event_image)" />
                  <h5 class="pb-2 w-full">Bilgiler</h5>
                  <div class="control-wrapper vx-col px-1 pb-2">
                    <div class=" vx-row flex flex-wrap m-0">
                      <div class="vx-col w-1/2">
                        <div class="control-title">Bölge :</div>
                        <div class="control-value">{{getEventPropString(marker.event.bolge_adi) }}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">İşletme :</div>
                        <div class="control-value">{{getEventPropString(marker.event.isletme_adi)}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Kule Adı :</div>
                        <div class="control-value">{{getEventPropString(marker.event.kule_adi)}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Şeflik Adı :</div>
                        <div class="control-value">{{getEventPropString(marker.event.seflik_adi)}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Sıcaklık :</div>
                        <div class="control-value">{{getEventPropString(marker.event.sicaklik)}} °C</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Nem :</div>
                        <div class="control-value">{{getEventPropString(marker.event.nem)}}%</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Rüzgar Yönü :</div>
                        <div class="control-value">{{getEventPropString(marker.event.ruzgar_acisi)}}° {{getEventPropString(marker.event.ruzgar_yonu)}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Rüzgar Hızı : </div>
                        <div class="control-value">{{getEventPropString(parseFloat(marker.event.ruzgar_hizi) * 3.6) === '-' ? '-' : getEventPropString(parseFloat(marker.event.ruzgar_hizi) * 3.6).toFixed(2).toString()}} km/s</div>
                      </div>
                      <div class="vx-col w-full">
                        <div class="control-title">Yangın Koordinatı :</div>
                        <div class="control-value">{{getEventCoordString(marker.event.yangin_koordinati)}}</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Yangın Rakımı :</div>
                        <div class="control-value">{{getEventPropString(marker.event.yangin_rakimi)}} m</div>
                      </div>
                      <div class="vx-col w-1/2">
                        <div class="control-title">Yangın Uzaklığı :</div>
                        <div class="control-value">{{getEventPropString(marker.event.yangin_uzakligi)}} m</div>
                      </div>
                    </div>
                  </div>

                </div>
              </google-map-infowindow>

            </div>
          </div>
        </google-map>
      </div>
    </div>
  </div>
</template>
<script>

import EditEventPopup from '../layouts/components/navbar/components/EditEventPopup'
import EventsDetail from './EventsDetail'
import CamController from '../layouts/components/customizer/CamController'

import { VueTreeList, Tree } from 'vue-tree-list'
export default {
  props: {
    id: {
      type: String
    }
  },
  components: {
    VueTreeList,
    EditEventPopup,
    EventsDetail,
    CamController
  },
  data () {
    return {
      pitch:0,
      rotation:0,
      zoom:0,
      treeEventData: [
        {
          id: -1,
          name: 'Tüm Bölgeler',
          addTreeNodeDisabled: true,
          addLeafNodeDisabled: true,
          editNodeDisabled: true,
          delNodeDisabled: true,
          dragDisabled: true,
          children: []
        }
      ],
      showFullScreen: false,
      infoOptions:{
        pixelOffset: new window.google.maps.Size(0, -52)
      },
      showFire: true,
      treeData: new Tree([]),
      itemsPerPage: 20,
      isMounted: false,
      defaultMapOptions: {
        zoom: 12.5,
        minZoom: 3,
        center: {
          lat: 0,
          lng: 0
        },
        yangin: {
          lat: 0,
          lng: 0
        },
        title: '',
        description: '',
        streetViewControl: false,
        zoomControl:false,
        mapTypeControl: false,
        mapTypeId: 'satellite',
        draggable: false,
        scrollwheel: false
      },
      mapHeight: 0,
      showInfo: false,
      selectedEvent: null,
      selectedMarker: { showInfo: false, showFireInfo: false, event: {event_image: ''} },
      markers: [],
      showMap: false,
      bounds: null,
      map: null,
      view_state: 0, //0 general, 1 regional, 2 detail
      selected:[],
      viewPortBorders: [
        {
          lat: 38.500793,
          lng: 28.165186
        },
        {
          lat: 41.654464,
          lng: 35.036778
        },
        {
          lat: 39.427944,
          lng: 43.002998
        },
        {
          lat:37.034364,
          lng:35.295071
        }
      ]
    }
  },
  beforeDestroy () {
    clearInterval(this.intervalObject)
  },
  mounted () {
    this.getEventList(false)
    this.intervalObject = setInterval(() => {
      console.log('alarm mode', this.alarm_mode)
      if (this.view_state === 0 && this.alarm_mode) {
        this.getEventList(true)
      }
    }, 5000)
    this.bounds = new window.google.maps.LatLngBounds()

    this.map = this.$refs.map
    console.log('bounds', this.bounds)
    this.showFire = false

  },
  computed: {
    eventImage () { return this.$store.state.eventImage },
    alarm_mode () {
      return this.$store.state.alarm_mode
    },
    showImagePopup () { return this.$store.state.showImagePopup },
    getIcon () {
      return require('@/assets/images/arf/fire64x64.png')
    },
    getTowerIcon () {
      return require('@/assets/images/arf/tower64x64.png')
    },
    getFireIcon () {
      return require('@/assets/images/arf/fire64x64.png')
    },
    event_data () {
      return this.$store.state.event_data.filter((event) => {
        if (event.event.status === 'None' || event.event.status === '0' || event.event.status === '2' || event.event.status === '3' || (this.id && event.event.status === '1')) {
          return event
        }
      })
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.event_data.length
    },
    getTowerLocation () {
      let event = this.selectedEvent
      if (!this.selectedEvent) {
        event = this.event_data[0]
      }

      const result = {
        position: {
          lat: parseFloat(event.kule_koordinati.split(' ')[0]),
          lng: parseFloat(event.kule_koordinati.split(' ')[1])
        }
      }
      return result
    },
    getFireLocation () {
      const event = this.selectedEvent
      const result = {
        position: {
          lat: parseFloat(event.yangin_koordinati.split(' ')[0]),
          lng: parseFloat(event.yangin_koordinati.split(' ')[1])
        }
      }

      return result
    }
  },
  watch: {
    showFire (val) {
      console.log('viewing fire', val)
      this.defaultMapOptions.scrollwheel = true
      this.defaultMapOptions.draggable = true
    },
    selectedMarker (val) {
      console.log('watching marker', val)
    }
  },
  methods: {
    ConvertDDToDMS (D) {
      const result = [0 | D, '° ', 0 | (D < 0 ? D =  -D : D) % 1 * 60, '\' ', 0 | D * 60 % 1 * 60, '" '].join('')
      return result
    },
    getEventCoordString (coords) {
      if (coords === '') {
        return '-'
      } else {
        const lat = coords.split(' ')[0]
        const longti = coords.split(' ')[1]

        const latDMS = this.ConvertDDToDMS(lat)
        const lonDMS = this.ConvertDDToDMS(longti)

        return  `${latDMS} ${lonDMS}`
      }
    },
    getEventPropString (string) {
      if (string) {
        if (string === '') {
          return '-'
        } else {
          return  string
        }
      } else {
        return  '-'
      }

    },
    closeDetail () {
      this.selectedMarker.showInfo = false
      this.selectedMarker.showFireInfo = false
      this.generalView()
    },
    handle_event_id (event, marker) {
      console.log('found event ', event)
      const child_kule_koord = this.getTowerLocationFromEvent(event)
      console.log('event kule koord ', child_kule_koord)
      this.bounds.extend(child_kule_koord.position)
      if (event.yangin_koordinati !== '') {
        const child_yangin_koord = this.getYanginLocationFromEvent(event)
        this.bounds.extend(child_yangin_koord.position)
      } else {
        this.defaultMapOptions.center = child_kule_koord.position
      }

      this.map.fitBounds(this.bounds)

      this.showFire = true

      this.selectedMarker = marker

      marker.showInfo = false

      marker.showFireInfo = false

      this.view_state = 2
    },
    reset_data () {
      this.treeEventData = [
        {
          id: -1,
          name: 'Tüm Bölgeler',
          addTreeNodeDisabled: true,
          addLeafNodeDisabled: true,
          editNodeDisabled: true,
          delNodeDisabled: true,
          dragDisabled: true,
          children: []
        }
      ]
      this.markers = []
    },
    list_clicked (e) {
      console.log(e)
      this.bounds = new window.google.maps.LatLngBounds()
      if (e.id === -1) {
        this.generalView()
        this.showFire = false
        this.view_state = 0
      } else if (e.children) {
        console.log('has child')
        e.children.map((child) => {
          console.log('child', child)
          const child_kule_koord = this.getTowerLocationFromEvent(child.event)
          console.log('kule koord', child_kule_koord.position)
          this.bounds.extend(child_kule_koord.position)
        })
        this.showFire = true
        this.map.fitBounds(this.bounds)
        this.selectedMarker = { event: {event_image: ''} }
        this.view_state = 1
      } else {
        console.log('has no child')
        const child_kule_koord = this.getTowerLocationFromEvent(e.event)
        this.bounds.extend(child_kule_koord.position)
        if (e.event.yangin_koordinati !== '') {
          const child_yangin_koord = this.getYanginLocationFromEvent(e.event)
          this.bounds.extend(child_yangin_koord.position)
        } else {
          this.defaultMapOptions.center = child_kule_koord.position
        }

        this.map.fitBounds(this.bounds)

        this.showFire = true

        this.selectedMarker = e.marker

        e.marker.showInfo = false

        e.marker.showFireInfo = false

        this.view_state = 2

      }
    },
    getFireIconColor (status) {
      let return_image = null
      let view_state_val = '30x30'
      if (this.view_state === 2) {
        view_state_val = '25x25'
      }
      switch (status) {
      case 'None':
        return_image = require(`@/assets/images/gifs/${view_state_val}/${view_state_val}_sari.gif`)
        break
      case '0':
        return_image = require(`@/assets/images/gifs/${view_state_val}/${view_state_val}_kirmizi.gif`)
        break
      case '1':
        return_image = require(`@/assets/images/gifs/${view_state_val}/${view_state_val}_gri.gif`)
        break
      case '2':
        return_image = require(`@/assets/images/gifs/${view_state_val}/${view_state_val}_turuncu.gif`)
        break
      case '3':
        return_image = require(`@/assets/images/gifs/${view_state_val}/${view_state_val}_yesil.gif`)
        break
      case '4':
        return_image = require(`@/assets/images/gifs/${view_state_val}/${view_state_val}_gri.gif`)
        break

      }

      return return_image
    },
    getEventImageUrl (url) {

      if (url !== '') {
        if (!url.startsWith('https')) {
          return 'https://api.arftower.com'.concat(url)
        } else {
          return url
        }
      } else {
        return 'http://placehold.jp/1920x1080.png'
      }

    },
    getPathFromEvent (event) {
      return [this.getTowerLocationFromEvent(event).position, this.getYanginLocationFromEvent(event).position]
    },
    getTowerLocationFromEvent (event) {
      const result = {
        position: {
          lat: parseFloat(event.kule_koordinati.split(' ')[0]),
          lng: parseFloat(event.kule_koordinati.split(' ')[1])
        }
      }
      return result
    },
    getYanginLocationFromEvent (event) {
      const result = {
        position: {
          lat: parseFloat(event.yangin_koordinati.split(' ')[0]),
          lng: parseFloat(event.yangin_koordinati.split(' ')[1])
        }
      }
      return result
    },
    infoClicked (event) {
      console.log('info image clicked')
      this.$store.commit('TOGGLE_IMAGE_POPUP', !this.showImagePopup)
      this.$store.commit('SET_EVENT_IMAGE_PREVIEW', this.getEventImageUrl(event.event_image))
    },
    toggleInfoWindow (marker) {
      console.log('marker clicked')
      marker.showInfo = !marker.showInfo
    },
    toggleFireInfoWindow (marker) {
      console.log('marker clicked')
      this.markers.map((marker_item) => {
        if (marker.event.id !== marker_item.event.id) {
          marker_item.showFireInfo = false
        }
      })
      marker.showFireInfo = !marker.showFireInfo
    },
    getEventList (isRefresh) {
      if (!isRefresh) {
        this.$vs.loading()
      }
      console.log('event list func')
      const payload = {
        page: 1,
        items: 100
      }

      this.$store.dispatch('getEvents', payload)
        .then((response) => {
          console.log('event list events page', response)
          if (!isRefresh) {
            this.$vs.loading.close()
            this.isMounted = true
          }
          this.setAllEventsMap(isRefresh)
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error', error)
        })
    },
    setAllEventsMap (isRefresh) {
      let index = 0
      this.reset_data()
      console.log('event data', this.event_data)
      let found_event = null
      let found_marker = null
      this.event_data.forEach((event) => {
        const event_val = event.event
        console.log(`event ${index} `, event_val)
        const marker = {
          position: this.getTowerLocationFromEvent(event_val).position,
          yangin: (event_val.yangin_koordinati !== '') ? this.getYanginLocationFromEvent(event_val).position : null,
          event: event_val,
          data_map: event,
          showInfo: false,
          showFireInfo: false
        }
        this.markers.push(marker)
        const existingElement = this.treeEventData[0].children.filter((elem) => {
          if (elem.name === event.bolge.name) return elem
        })

        if (existingElement.length > 0) {
          existingElement[0].children.push({
            id: index,
            name: `${event.kule.name}`,
            addTreeNodeDisabled: true,
            addLeafNodeDisabled: true,
            editNodeDisabled: true,
            delNodeDisabled: true,
            dragDisabled: true,
            event: event_val,
            marker
          })
        } else {
          const event_item = {
            name: event.bolge.name,
            id: event_val.id,
            children: [],
            addTreeNodeDisabled: true,
            addLeafNodeDisabled: true,
            editNodeDisabled: true,
            delNodeDisabled: true,
            dragDisabled: true,
            event: event_val,
            marker
          }
          event_item.children.push({
            name: `${event.kule.name}`,
            id: index,
            addTreeNodeDisabled: true,
            addLeafNodeDisabled: true,
            editNodeDisabled: true,
            delNodeDisabled: true,
            dragDisabled: true,
            event: event_val,
            marker
          })
          this.treeEventData[0].children.push(event_item)
        }

        console.log('event id', this.id)
        if (this.id === event_val.id && !isRefresh) {
          console.log('they r equal')
          found_event = event_val
          found_marker = marker
        }
        index += 1
      })
      this.treeData = new Tree(this.treeEventData)
      //this.selectedEvent = this.event_data[0]
      this.showMap = true
      //this.view_state = 0
      console.log('tree data', this.treeEventData)

      if (!isRefresh) {
        if (found_event !== null) {
          this.handle_event_id(found_event, found_marker)
        } else {
          this.generalView()
        }
      }
    },
    setEventMap (event) {
      const location = {
        lat: parseFloat(event.kule_koordinati.split(' ')[0]),
        lng: parseFloat(event.kule_koordinati.split(' ')[1])
      }

      const location_yangin = {
        lat: parseFloat(event.yangin_koordinati.split(' ')[0]),
        lng: parseFloat(event.yangin_koordinati.split(' ')[1])
      }
      console.log(location)
      this.defaultMapOptions.center = location
      if (event.yangin_koordinati !== '') {
        this.defaultMapOptions.yangin = location_yangin
      }

      this.selectedEvent = event
    },
    getRowColor (status) {
      return {
        'yangin'   : status === '0',
        'yangin-degil'   : status === '1',
        'yangin-kontrol'   : status === '2',
        'yangin-sondu' : status === '3'
      }
    },
    generalView () {
      this.bounds = new window.google.maps.LatLngBounds()
      this.viewPortBorders.map((item) => {
        this.bounds.extend(item)
      })
      this.view_state = 0
      this.selectedMarker = { event: {event_image: ''} }
      this.map.fitBounds(this.bounds)
    }
  }
}
</script>
<style lang="scss">
.font-size-12 {
  font-size:12px;
}
.control-button {
  font-size:12px;
}
  .control-input {
    .vs-input--input.normal {
      padding: 0.1rem !important;
    }
  }
  .gm-style-iw-d {
    overflow: auto !important;
    padding: 0 12px 12px 0;
    max-width: 300px !important;
  }
  .google-map-info-windows img {
    width: 100%;
  }
  .info-image {
    max-width: 100px;
  }
  .product-img {
    max-width: 100px;
  }

  .control-wrapper {
    .vx-col {
      font-size: 12px;
    }
  }

  .map-events {
    .vtl{
      padding-left: 5px;
    }
    .vs-con-table .vs-con-tbody {
      height:60vh;
    }
    #video-player {
      background: #555;

    }

    #map {
      height: calc(100vh - 55px);
    }
    .vx-col {
      padding: 0;
    }
    .vtl-node-content {
      font-size: 12px;
    }
    .vtl-node-main {
      cursor: pointer;
      padding: 0 !important;
    }
    .vtl {
      .vtl-node-main:hover {
        color:black;
      }
    }
  }
  .white-bg-round {
    background: rgba(255, 255, 255, 0.4);
  }
  .close-button span{
    background: rgba(255, 255, 255, 0.8);
    padding: 2px;
    margin: 4px;
    border-radius: 50%;
  }

.control-wrapper {
  .vx-col {
    margin-bottom: 5px;
  }
  .vx-col {
    background: #182625;
  }
}
</style>
